<script>
import { mapActions, mapGetters } from 'vuex'
import offerGroupForm from './offer-group-form.vue'

export default {
  name: 'OfferGroupNew',
  page: {
    title: 'New Offer Group',
  },
  components: {
    offerGroupForm,
  },
  data() {
    return {
      offerGroup: {},
      loading: true,
      backRoute: { name: 'offer-groups' },
    }
  },
  computed: {
    ...mapGetters('offerGroup', [
      'getOfferGroupFromState',
    ]),

    offerGroupId() {
      return this.$route.params.id
    },
    title() {
      return this.getOfferGroupFromState ? `Update Offer Group ${this.getOfferGroupFromState.name}` : 'New Offer Group'
    },
  },
  async mounted() {
    if (this.offerGroupId) {
      await this.fetchOfferGroup()
    } else {
      this.loading = false
    }
  },
  methods: {
    ...mapActions('offerGroup', [
      'getOfferGroup',
      'getOffersForGroup',
    ]),

    async fetchOfferGroup() {
      this.loading = true
      const [offerGroup, offers] = await Promise.all([
        this.getOfferGroup(this.offerGroupId),
        this.getOffersForGroup(this.offerGroupId),
      ])

      const [error] = offerGroup
      const [errorOffers] = offers

      if (error || errorOffers) {
        this.$router.replace(this.backRoute)
      }

      this.loading = false
    },
  },
}
</script>

<template>
  <main-layout
    :loading="loading"
    :title="title"
    :back="backRoute"
  >
    <data-box :status="false">
      <offer-group-form />
    </data-box>
  </main-layout>
</template>
